import * as React from 'react'
import { render } from 'react-dom'
import Root from './containers/Root'

import 'core-js/fn/object/assign';

render(
    <Root />,
    document.getElementById( 'references-view-app' )
)


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/boot-client.tsx
 **/